/**
 * permet de boucler sur les éléments gigogne en évitant les infiniteLoop
 * @returns 
 */
const getCircularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

/**
 * Classe utile pour parser cloner les objets tout en gérant les références circulaires
 */
export class WizJSONUtils {
  public static clone(object: any, handleCircular: boolean = true): any {
    if (handleCircular) {
      return JSON.parse(JSON.stringify(object, getCircularReplacer()));
    } else {
      return JSON.parse(JSON.stringify(object));
    }
  }
}
